export function mapTree(categories, products) {
  categories.forEach(category => {
    fixChildrens(category)
    if (products) {
      category.products = products.filter(product => {
        return product.category && product.category.id === category.id
      })
    }
  })

  let map = {}, node, roots = [], i;
  categories.forEach((category, i) => {
    map[category.id] = i
    if (category.products) {
      let products = [...category.products]
      category.children = products.map(product => ({...product, isProduct: true}))
    } else {
      category.children = []
    }
  })

  categories.forEach((category, i) => {
    node = category
    if (category.parent) {
      let parent = categories[map[category.parent.id]]
      parent.children.push(category);
    } else {
      roots.push(category);
    }
  })

  return roots;
}

function fixChildrens(cat) {
  if (!cat.childrens) return
  cat.children = cat.childrens.map(cat => fixChildrens(cat))
  delete cat.childrens
}

export const filterByProperty = ({products, property, value}) => {

}



// WEBPACK FOOTER //
// ./src/utils/products.js